import React from 'react';

import Board from '../../organisms/Board/Board';

function BoardView(props) {
  return <Board {...props} />;
}

export default BoardView;
